import { getTimeInHoursAndMins } from './dates';

// Function to calculate and format the total number of sites
export const calculateAndFormatSites = (sites) => {
  let totalSitesText = '';
  if (sites.length === 0) {
    totalSitesText = '0 sites';
  } else if (sites.length === 1) {
    totalSitesText = '1 site';
  } else {
    totalSitesText = `${sites.length} sites`;
  }
  return totalSitesText;
};

// Function to calculate and format the total distance
export const calculateAndFormatDistance = (sites, totalDistance) => {
  if (!sites.length || ['NaN', null].includes(totalDistance)) {
    return 'Distance unknown';
  }
  if (sites.length === 1) {
    return '0mi';
  }
  if (totalDistance % Math.round(totalDistance) !== 0) {
    return `${totalDistance?.toFixed(2)}mi`;
  }
  return `${totalDistance}mi`;
};

// Function to calculate and format the total time
export const calculateAndFormatTime = (sites, totalTime) => {
  if (sites.length === 0) {
    return 'N/A';
  }
  if (sites.length === 1) {
    return '0min';
  }
  return getTimeInHoursAndMins(totalTime);
};

// Function to format time in hours and minutes
export const formatTime = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (hours > 0) {
    return `${hours}hr ${remainingMinutes}min`;
  }
  return `${remainingMinutes}min`;
};

